<template>
	<div class="livePage">
		<div class="PC_headImg">
			<img src="../../assets/headImg/headimg.jpg" alt="">
		</div>
		<div class="phone_headImg">
			<img src="../../assets/headImg/feoug.jpg" alt="" style="width: 100%;">
		</div>
		<div>
			<pcBack></pcBack>
		</div>
		<!-- 5.17新增 -->

		<p style="text-align:center;">
			<span style="font-size:20px;color: rgb(20, 90, 245);"><strong>中华医学会<br>第二次全国细菌真菌感染学术会议</strong></span>
		</p>

		<div class="explain">
			<span>
				2021年4月10日，由中华医学会、中华医学会细菌感染与耐药防治分会主办，复旦大学附属华山医院抗生素研究所协办的“中华医学会第一次全国细菌真菌感染学术会议”，
				在上海跨国采购会展中心落下帷幕。</span>
			<span>
				本次学术会议是中华医学会细菌感染与耐药防治分会的首次年会，开设6个分会场，讲者主持团队近170人，
				就细菌真菌感染相关疾病的诊疗和抗菌药物合理应用等方面的热点、难点问题进行了多学科的深入交流与探讨。</span>

			<span> 经专家讨论决定，第二届中华医学会全国细菌真菌感染学术会议定于2022年4月在广州越秀国际会展中心召开。</span>
			<span> 欢迎感染病诊治相关的临床各科医师和从事临床微生物学、医院感染防控、临床药学、抗感染药临床药理学、抗菌药物管理、新药研发的专业人员踊跃参加。</span>
		</div>
		<!-- <div class="bottomNav">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane name="0">
					<span slot="label"><i class="el-icon-date"></i> 9日上午主会场</span>
					<div class="navImg">
						<div v-for="(item,index) in keyList" :key="index">
							<img :src="item.src" alt="" @click="Url(item)">
							<hr v-if="!(index == keyList.length - 1)">
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane name="1">
					<span slot="label"><i class="el-icon-date"></i> 9日下午主会场</span>
					<div class="navImg">
						<div v-for="(item,index) in keyList2" :key="index">
							<img :src="item.src" alt="" @click="Url(item)">
							<hr v-if="!(index == keyList2.length - 1)">
						</div>


					</div>
				</el-tab-pane>
				<el-tab-pane name="2">
					<span slot="label"><i class="el-icon-date"></i> 10日全天主会场</span>
					<div class="navImg">
						<div v-for="(item,index) in keyList3" :key="index">
							<img :src="item.src" alt="" @click="Url(item)">
							<hr v-if="!(index == keyList3.length - 1)">
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div> -->
		<div>
			<logocom></logocom>
		</div>
	</div>

</template>

<script>
	import pcBack from '../../components/back/back.vue';
	import logocom from '../../components/logo/logo.vue';
	import merge from 'webpack-merge';
	export default {
		data() {
			return {
				number: 911,
				value: '100',
				activeName: '0',
				keyList: [{
					id: "475119",
					key: "hzt5jS50BFrL",
					src: require("../../assets/live/开幕式.jpg"),
				}, {
					id: "543866",
					key: "xyfMa27hcIZE",
					src: require("../../assets/live/主会场学术报告.jpg"),
				}],
				keyList2: [{
					id: "475024",
					key: "RHRaEHP0fU2D",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-28.jpg"),
				}, {
					id: "475025",
					key: "JQ0OQB4B7XDs",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-29.jpg"),
				}, {
					id: "475027",
					key: "Z1EaPsUs272B",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-30.jpg"),
				}, {
					id: "475028",
					key: "MHmFGjguT3fR",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-31.jpg"),
				}, {
					id: "475029",
					key: "mjkKGp7f4I76",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-32.jpg"),
				}, {
					id: "475032",
					key: "eXhXeYJ8pSlT",
					src: require("../../assets/live/4.9/(Banner-4月9日）第一届细菌感染峰会－微网站-2.9-33.jpg"),
				}],
				keyList3: [{
					id: "475037",
					key: "OvahmHAAJadX",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-40.jpg"),
				}, {
					id: "475038",
					key: "xmnogi6whiEs",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-41.jpg"),
				}, {
					id: "475041",
					key: "GzWnjVqtzrrp",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-42.jpg"),
				}, {
					id: "475044",
					key: "Py13GlPs9MET",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-43.jpg"),
				}, {
					id: "475045",
					key: "G6vFETwJWbZU",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-44.jpg"),
				}, {
					id: "475046",
					key: "PV2bBoo9JqzZ",
					src: require("../../assets/live/4.10/(Banner-4月10日）第一届细菌感染峰会－微网站-2.9-45.jpg"),
				}]
			}
		},
		components: {
			pcBack,
			logocom,
		},
		methods: {
			Url(item) {
				console.log(item)
				if (localStorage.getItem("user")) {
					let info = JSON.parse(localStorage.getItem("user"))
					this.$api.getUserLiveUrl({
						phone: info.user.phone,
						id: item.id,
						key: item.key,
					}, res => {
						if (res.data && res.data.rc == this.$util.RC.SUCCESS) {

							window.location.href = res.data.c
							// this.$router.push({
							// 	path:'/LivePage'
							// })
						} else {
							this.$message.error(res.data.rm);
						}
					});
				} else {
					var r = confirm("您当前没有登录，请先注册会议网站并进行登录，方可观看本次大会直播");
					if (r == true) {
						localStorage.removeItem('user');
						this.$router.push({
							path: '/signIn'
						})
					}
				}
			},
			handleClick(tab, event) {
				this.$router.push({
					query: merge(this.$route.query, {
						'index': tab.index
					})
				})
			}
		},
		created() {
			this.activeName = this.$route.query.index
		}
	}
</script>

<style>
	.line {
		width: 100%;
		height: 1px;
		border-top: 1px solid rgba(0, 0, 0, 0.2);
	}

	//弹性布局
	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.livePage {
		width: 61.25rem;
		margin: 0 auto;
	}

	.PC_headImg {
		margin: 0 auto;
		display: block;
	}

	.PC_headImg img {
		width: 100%;
	}

	.phone_headImg {
		display: none;
	}

	.navImg img {
		width: 28.75rem;
		height: 6.25rem;
		display: block;
		margin: 0 auto;
	}

	.navImg hr {
		height: 4px;
		background-color: #1855e3;
		width: 60%;
	}

	@media (max-width:31.25rem) {
		.PC_headImg {
			display: none;
		}

		.phone_headImg {
			display: block;

		}

		.livePage {
			width: 100%;
		}

		.navImg {
			width: 100%;
		}

		.navImg img {
			width: 90%;
			height: auto;
		}
	}

	.explain {
		width: 90%;
		margin: 1.875rem auto;
	}

	.explain span {
		display: block;
		font-size: 1.125rem;
		text-indent: 2.25rem;
		line-height: 2.5rem;

	}
</style>
